import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { ListItemRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: ListItemRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function ListItemRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "listItem",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("ListItemRegionTypeCard.title")}
      description={t("ListItemRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
